// src/apiConfig.js
//const API_BASE_URL = 'http://172.20.10.6:5000';
const API_BASE_URL = 'https://midlandsoutdoorarchery.com';
export default API_BASE_URL;